import { NgModule } from '@angular/core';
import { AvailabilityEffectsModule } from './effects'; //

@NgModule({
  imports: [AvailabilityEffectsModule],
})
export class AvailabilityFeatureModule {}
